/** @format */
/** @format */

import React, { FC, useState, useRef, useMemo } from 'react'
import styled from 'styled-components'
import {
  Form,
  FormItem,
  Input,
  ButtonGroup,
  Select,
  Option,
  Button,
  Icon,
  Message,
  Switch,
  Skeleton,
  Checkbox,
  Card,
  Tooltip,
  _$
} from '@king-design/react'
import { AddButon, MonitorCrumb } from 'src/components'
import variable from 'src/static/styles/var'
import {
  initEditPolicyRule,
  EditPolicyProps,
  initTemplateValues,
  initPolictValues,
  jsonToYaml,
  initYaml,
  validateEditEmpty
} from 'src/pages/PrometheusMonitor/Alarm/constants'
import RuleFormItem from 'src/pages/PrometheusMonitor/Alarm/components/RuleFormItem'
import RulePreview from 'src/pages/PrometheusMonitor/Alarm/components/RulePreview'
import AlarmCallBack, { handleCallbackType } from 'src/components/AlarmCallBack/new'
import AlarmReciver, { handleWayToChannels } from 'src/components/AlarmReciver/new'
import YamlCodemirror from 'src/components/YamlCodemirror'
import { useHistory, useLocation } from 'react-router'
import { getPromethuesInstance } from 'src/api/ApiPromethuesInstance'
import {
  getPrometheusAlertPolicyList,
  createPrometheusAlertPolicy,
  updatePrometheusAlertPolicy,
  getPrometheusAlertTemplate,
  getPrometheusAlertTemplateList,
  createPrometheusAlertTemplate,
  updatePrometheusAlertTemplate,
  validateAlertRule
} from 'src/api/ApiPrometheusAlarm'
import { cloneDeep } from 'lodash'
import { useAsync, useAsyncFn } from 'react-use'
import useNavRegion from 'src/hooks/useNavRegion'
import yaml from 'js-yaml'
export const ShieldTimeTypeOpts = {
  1: '永久生效',
  2: '绝对时间范围',
  3: '相对时间范围(每天循环)'
}

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

interface AlarmEditPageProps {
  className?: string
}
const AlarmEditPage: FC<AlarmEditPageProps> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const policyid = query.get('policyid')
  const rulename = query.get('rulename')
  const page = query.get('page')
  const templateid = query.get('templateid')
  const tab = query.get('tab')
  // form表单
  const formRef = useRef(null)
  const [formValue, setFormValue] = useState<EditPolicyProps>(initPolictValues)
  const [template, setTemplate] = useState()
  // PromQL数据预览
  const [prviewVisible, setPrviewVisible] = useState(false)
  const [prviewExpr, setPrviewExpr] = useState('')
  // 控制台region
  const region = useNavRegion()
  // 初始化
  const { loading } = useAsync(async () => {
    if (policyid) {
      const result = await getPrometheusAlertPolicyList({
        PolicyID: parseInt(policyid)
      })
      if (result?.Polices?.length) {
        const policy = result.Polices[0]
        setFormValue({
          ...initPolictValues,
          Name: policy.Name,
          InstanceIDs: policy.InstanceIDs,
          Recipients: policy.Recipients.map(item => ({
            ...item,
            ContactChannels: handleWayToChannels(item.ContactChannels || item.ContactWay)
          })),
          URLNotices: policy.URLNotices || handleCallbackType(policy.WebHooks) || [],
          Yaml: jsonToYaml(policy.Rules),
          Rules: policy.Rules.map(rule => {
            return {
              ...rule,
              Expand: true,
              State: rule.State,
              For: rule.For.slice(0, -1),
              ForUnit: rule.For.slice(-1)
            }
          }),
          SaveAsTemplate: false
        })
      } else {
        setFormValue({ ...initPolictValues })
        Message.error('策略不存在')
      }
    } else if (templateid) {
      const result = await getPrometheusAlertTemplate({
        TemplateID: parseInt(templateid)
      })
      if (result?.AlertTemplate) {
        const { Name, Rules } = result?.AlertTemplate
        setFormValue({
          CreateType: 'page',
          Name,
          Yaml: '',
          Rules: Rules?.map((rule, index) => {
            return {
              ...rule,
              Expand: true,
              State: rule.State,
              For: rule.For.slice(0, -1),
              ForUnit: rule.For.slice(-1)
            }
          }) || [initEditPolicyRule]
        })
      } else {
        setFormValue({ ...initTemplateValues })
        Message.error('模板不存在')
      }
    }
  }, [policyid, rulename, templateid])

  // 账户下实例
  const { value: instances, loading: instancesLoading } = useAsync(async () => {
    if (region && page !== 'template') {
      const result = await getPromethuesInstance({
        SearchRegion: region
      })
      return (
        result?.InstancesSet?.map(item => {
          return { name: item.InstanceName, id: item.ControllerID }
        }) || []
      )
    } else {
      return []
    }
  }, [region, page])

  // 模板列表
  const { value: templateList, loading: templateListLoading } = useAsync(async () => {
    const result = await getPrometheusAlertTemplateList({
      Page: 1,
      PageSize: 9999,
      Type: page === 'template' ? 1 : 0
    })
    return result?.AlertTemplates
  }, [page])

  // YAML 校验
  const [, validateYaml] = useAsyncFn(async yaml => {
    const result = await validateAlertRule({ RuleGroup: yaml })
    return result?.Rules
  }, [])

  // 查询模板详情
  const [, templateDetailFetch] = useAsyncFn(
    async TemplateID => {
      const result = await getPrometheusAlertTemplate({
        TemplateID
      })
      if (result?.AlertTemplate) {
        setFormValue({
          ...formValue,
          Yaml: jsonToYaml(result.AlertTemplate.Rules),
          Rules: result.AlertTemplate.Rules?.map(rule => {
            return {
              ...rule,
              Expand: true,
              State: rule.State,
              For: rule.For.slice(0, -1),
              ForUnit: rule.For.slice(-1),
              RuleID: undefined
            }
          }) || [initEditPolicyRule]
        })
        Message.success('模板详情加载成功')
      }
      return result?.Rules
    },
    [formValue]
  )

  // 修改表单
  const onChangeValues = values => {
    setFormValue({
      ...formValue,
      ...values
    })
  }

  // 提交
  const formSubmit = async () => {
    const validate = await formRef?.current?.validate()
    try {
      if (validate) {
        const {
          Name,
          InstanceIDs,
          Recipients,
          URLNotices,
          CreateType,
          Yaml,
          Rules,
          SaveAsTemplate,
          TemplateName
        } = formValue
        let params: Partial<EditPolicyProps> = {
          Name: Name
        }
        if (CreateType === 'yaml') {
          const validateYaml = await validateAlertRule({ RuleGroup: Yaml })
          if (validateYaml?.Rules?.length) {
            params.Rules = validateYaml?.Rules.map((item, index) => {
              const { Alert, Expr, Labels, Annotations, For } = item
              return {
                RuleID: Rules[index]?.RuleID || 0,
                State: Rules[index]?.State || 1,
                Alert,
                Expr,
                For,
                Labels,
                Annotations
              }
            })
          } else {
            return true
          }
        } else {
          params.Rules = Rules.map((item, index) => {
            const { State, Alert, Expr, For, Labels, Annotations, ForUnit, RuleID } = item
            return {
              Alert,
              RuleID,
              Expr,
              For: `${For}${ForUnit}`,
              Labels,
              Annotations,
              State
            }
          })
        }
        let result
        // 告警模板
        if (page === 'template') {
          result = templateid
            ? await updatePrometheusAlertTemplate({
                ID: parseInt(templateid),
                ...params
              })
            : await createPrometheusAlertTemplate(params)
        } else {
          // 告警策略
          params = {
            ...params,
            PolicyType: 1,
            InstanceIDs: InstanceIDs,
            Recipients: Recipients.filter(item => !!item.ContactID),
            URLNotices,
            SaveAsTemplate,
            TemplateName: SaveAsTemplate ? TemplateName : ''
          }
          result = policyid
            ? await updatePrometheusAlertPolicy({
                PolicyID: parseInt(policyid),
                ...params
              })
            : await createPrometheusAlertPolicy(params)
        }
        if (result.code !== 'error') {
          Message.success(policyid || templateid ? '更新成功' : '创建成功')
          history.push(`/monitor/prometheusmonitor/alarm?tab=${tab}`)
        }
      } else {
        setFormValue(pre => ({ ...pre }))
      }
      return true
    } catch (e) {
      return false
    }
  }

  // 全部收起/展开
  const allExpand = useMemo(() => {
    return formValue?.Rules.every(item => item.Expand)
  }, [formValue])

  // 判断是否支持电话
  const showPhone = useMemo(() => {
    if (formValue.CreateType === 'page') {
      if (formValue.Rules?.length) {
        const find = formValue.Rules.find(item => item.Labels?.[0].Value === 'critical')
        return !!find
      } else {
        return false
      }
    } else {
      const yamlRules = yaml.load(formValue.Yaml)?.rules
      const find = yamlRules?.find(item => item.labels?.severity === 'critical')
      return !!find
    }
  }, [formValue.CreateType, formValue.Rules, formValue.Yaml])

  const pageTitle = useMemo(() => {
    if (page === 'template') {
      return templateid ? '编辑告警模板' : '新建告警模板'
    } else {
      return policyid ? '编辑告警策略' : '新建告警策略'
    }
  }, [page, policyid, templateid])

  return (
    <div className={className}>
      <MonitorCrumb
        breadArr={[
          { title: 'Prometheus监控', route: '/monitor/prometheusmonitor/alarm' },
          {
            title: '告警管理',
            route: `/monitor/prometheusmonitor/alarm?${tab ? `tab=${tab}` : ''}`
          },
          { title: pageTitle }
        ]}
      />

      <Card>
        {loading || instancesLoading || templateListLoading ? (
          <Skeleton loading={loading || instancesLoading || templateListLoading} />
        ) : (
          <Form className="form_container" starOnRequired ref={formRef} labelWidth={100}>
            <FormItem label="创建类型" value={formValue.CreateType} rules={{ required: true }}>
              <ButtonGroup
                checkType="radio"
                value={formValue.CreateType}
                onChangeValue={async value => {
                  if (value === 'yaml') {
                    const isEmpty = validateEditEmpty(formValue.Rules)
                    const yaml = isEmpty ? initYaml : jsonToYaml(formValue.Rules)
                    onChangeValues({
                      CreateType: value,
                      Yaml: yaml
                    })
                    // }
                  } else {
                    if (formValue.Yaml) {
                      const validate = await validateYaml(formValue.Yaml)
                      if (validate) {
                        const pageRules = validate.map((item, index) => {
                          const rule = formValue.Rules[index]
                          return {
                            ...item,
                            RuleID: rule?.RuleID || 0,
                            State: rule?.State || 1,
                            Expand: true,
                            For: (item.For as string)?.slice(0, -1),
                            ForUnit: (item.For as string)?.slice(-1)
                          }
                        })
                        onChangeValues({
                          CreateType: value,
                          Rules: pageRules
                        })
                      }
                    } else {
                      onChangeValues({
                        CreateType: value,
                        Rules: [initEditPolicyRule]
                      })
                    }
                  }
                  // validateYaml()
                  // onChangeValues({ CreateType: value })
                }}
              >
                <Button value="page">页面编辑</Button>
                <Button value="yaml">YAML编辑</Button>
              </ButtonGroup>
              <Tooltip content="若您在保存前，于页面编辑&YAML编辑均填写数据，最终将以YAML编辑提交内容为准">
                <Icon className="icon ion-help-circled" />
              </Tooltip>
            </FormItem>
            <FormItem
              label={page === 'template' ? '模板名称' : '策略名称'}
              value={formValue.Name}
              rules={{ required: true, userName: true }}
            >
              <Input
                onChangeValue={value => {
                  onChangeValues({
                    Name: value,
                    TemplateName:
                      page === 'policy' && !policyid && formValue.SaveAsTemplate ? value : ''
                  })
                }}
                placeholder={page === 'template' ? '请输入模板名称' : '请输入策略名称'}
                value={formValue.Name}
              ></Input>
            </FormItem>
            {page !== 'template' ? (
              <FormItem
                className="form_item_instance"
                label="关联资源"
                value={formValue.InstanceIDs}
                rules={{ required: true }}
              >
                <Select
                  value={formValue.InstanceIDs}
                  clearable
                  filterable
                  multiple
                  container={() => document.getElementsByClassName('form_item_instance')[0]}
                  onChangeValue={value => {
                    onChangeValues({ InstanceIDs: value })
                  }}
                >
                  {instances?.map(item => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </FormItem>
            ) : null}
            <FormItem
              className="form_item_template"
              label={page === 'template' ? '系统模板' : '告警模板'}
              value={template}
            >
              <Select
                value={template}
                clearable
                filterable
                container={() => document.getElementsByClassName('form_item_template')[0]}
                onChangeValue={value => {
                  setTemplate(value)
                  if (value) {
                    templateDetailFetch(value)
                  }
                }}
              >
                {templateList?.map(item => (
                  <Option key={item.ID} value={item.ID}>
                    {item.Name}
                  </Option>
                ))}
              </Select>
            </FormItem>
            {formValue.CreateType === 'page' ? (
              <FormItem
                className="form_item_rules"
                label="告警规则"
                value={formValue.Rules}
                rules={{
                  required: true
                }}
              >
                <div className="rules_content">
                  {formValue.Rules.length > 1 ? (
                    <div className="all_expand">
                      <Switch
                        on="全部收起"
                        off="全部展开"
                        width="82"
                        height="22"
                        value={allExpand}
                        onChangeValue={value => {
                          onChangeValues({
                            Rules: formValue.Rules.map(item => ({
                              ...item,
                              Expand: value
                            }))
                          })
                        }}
                      />
                    </div>
                  ) : null}
                  {formValue.Rules.map((item, index) => {
                    return (
                      <RuleFormItem
                        key={item.RuleID || index}
                        index={index}
                        page={page}
                        ruleValue={item}
                        ruleNameUnique={value => {
                          let count = 0
                          if (value && formValue?.Rules?.length) {
                            formValue?.Rules.find(item => {
                              if (item.Alert === value) {
                                count++
                              }
                              return count > 1
                            })
                            return count === 1 || '单个策略内，规则名称不允许重复'
                          }
                          return true
                        }}
                        onChangeValue={(values, index) => {
                          if (values) {
                            const copyRules = cloneDeep(formValue.Rules)
                            copyRules[index] = {
                              ...copyRules[index],
                              ...values
                            }
                            onChangeValues({
                              Rules: copyRules
                            })
                          } else {
                            const copyRules = cloneDeep(formValue.Rules)
                            if (copyRules.length === 1) {
                              Message.warning('至少保留一条告警规则')
                            } else {
                              copyRules.splice(index, 1)
                              onChangeValues({
                                Rules: copyRules
                              })
                            }
                          }
                        }}
                        onPreview={expr => {
                          setPrviewVisible(true)
                          setPrviewExpr(expr)
                        }}
                      />
                    )
                  })}
                  <AddButon
                    disabled={formValue.Rules?.length >= 10}
                    onClick={() => {
                      onChangeValues({
                        Rules: formValue.Rules.concat(initEditPolicyRule)
                      })
                    }}
                  />
                </div>
              </FormItem>
            ) : null}
            {formValue.CreateType === 'yaml' ? (
              <FormItem
                className="form_item_yaml"
                label="告警规则"
                value={formValue.Yaml}
                rules={{
                  required: true,
                  yaml: true
                }}
              >
                <YamlCodemirror
                  value={formValue.Yaml}
                  onChange={value => {
                    onChangeValues({ Yaml: value })
                  }}
                />
              </FormItem>
            ) : null}
            {page !== 'template' ? (
              <>
                <FormItem
                  label="通知对象"
                  slotLabel={
                    <>
                      通知对象
                      <Tooltip
                        hoverable
                        slotContent={
                          <>
                            <div>{_$('紧急（Critical）：邮件、短信、电话均会通知。')}</div>
                            <div>{_$('严重（Error）：邮件、短信通知。')}</div>
                            <div>{_$('警告（Warning）：仅邮件通知。')}</div>
                          </>
                        }
                      >
                        <Icon className="icontip ion-help-circled" />
                      </Tooltip>
                    </>
                  }
                  value={formValue.Recipients}
                  messages={{
                    required: '通知对象&告警回调至少选择一项配置'
                  }}
                  rules={{
                    required: formValue.URLNotices.length === 0
                  }}
                >
                  <AlarmReciver
                    style={{ width: 700 }}
                    showSchedule={true}
                    showPhone={showPhone}
                    value={formValue.Recipients}
                    onChange={value => {
                      onChangeValues({ Recipients: value })
                    }}
                  />
                </FormItem>
                <FormItem
                  label="告警回调"
                  value={formValue.URLNotices}
                  messages={{
                    required: '通知对象&告警回调至少选择一项配置'
                  }}
                  rules={{
                    required: formValue.Recipients.length === 0
                  }}
                >
                  <AlarmCallBack
                    style={{ width: 700 }}
                    value={formValue?.URLNotices}
                    onChange={value => {
                      onChangeValues({ URLNotices: value })
                    }}
                  />
                </FormItem>
                {/* <FormItem
                label={'通知时段'}
                value={[formValue.EffectiveStartTime, formValue.EffectiveEndTime]}
                rules={{ required: true }}
                messages={{
                  required: '请选择通知时段'
                }}
              >
                <Timepicker
                  range
                  showFormat="HH:mm"
                  valueFormat="HH:mm"
                  value={[formValue.EffectiveStartTime, formValue.EffectiveEndTime]}
                  onChangeValue={value => {
                    if (value?.length === 2) {
                      onChangeValues({
                        EffectiveStartTime: value[0],
                        EffectiveEndTime: value[1]
                      })
                    }
                  }}
                />
              </FormItem> */}
                {!policyid ? (
                  <>
                    <FormItem hideLabel>
                      <Checkbox
                        value={formValue.SaveAsTemplate}
                        onChangeValue={value => {
                          onChangeValues({
                            SaveAsTemplate: value,
                            TemplateName: formValue.TemplateName
                              ? formValue.TemplateName
                              : formValue.Name
                          })
                        }}
                      >
                        保存当前告警策略为模板
                      </Checkbox>
                      <Tooltip content="默认将告警策略名称设置为模板名称。保存后可前往告警模板页修改模板名称及内容。">
                        <Icon
                          style={{ lineHeight: '16px', marginTop: 4 }}
                          className="icon ion-help-circled"
                        />
                      </Tooltip>
                    </FormItem>

                    {formValue.SaveAsTemplate ? (
                      <FormItem
                        label="模板名称"
                        value={formValue.TemplateName}
                        rules={{ required: formValue.SaveAsTemplate, userName: true }}
                      >
                        <Input
                          onChangeValue={value => {
                            onChangeValues({ TemplateName: value })
                          }}
                          placeholder="请输入模板名称"
                          value={formValue.TemplateName}
                        ></Input>
                      </FormItem>
                    ) : null}
                  </>
                ) : null}
              </>
            ) : null}
          </Form>
        )}
      </Card>
      <div className="bottom_action">
        <Button onClick={() => formSubmit()} type="primary">
          确认
        </Button>
        <Button
          onClick={() => {
            history.goBack()
          }}
          type="default"
        >
          取消
        </Button>
      </div>
      {/* PromQL数据预览 Dialog */}
      <RulePreview
        visible={prviewVisible}
        onClose={() => {
          setPrviewVisible(false)
          setPrviewExpr('')
        }}
        expr={prviewExpr}
      />
    </div>
  )
}

export default styled(AlarmEditPage)`
  position: relative;
  padding-bottom: 80px;
  .k-icon {
    cursor: pointer;
    transition: all ease-in-out 0.3s;
    &:hover {
      color: ${variable.primaryColor};
    }
  }
  .k-card {
    padding: 16px 0;
    .k-card-body {
      height: calc(100vh - 212px);
      overflow-y: auto;
      padding-bottom: 0;
      padding-top: 0;
      padding-right: 0;
    }
  }
  .form_container {
    height: calc(100vh - 200px - 2rem);
    overflow: auto;
    .ion-help-circled {
      margin-left: 8px;
      line-height: 32px;
    }
  }
  .all_expand {
    line-height: 20px;
    margin-top: 5px;
    margin-bottom: 8px;
  }
  .form_item_rules {
    .rules_content {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
  }
  .form_item_yaml {
    .k-form-content {
      width: 700px;
    }
  }
  .k-radio {
    margin-right: 8px;
  }
  .bottom_action {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 64px;
    padding: 16px 0;
    background: #ffffff;
    border-top: 1px solid #f0f0f0;
    border-left: 1px solid #f0f0f0;
    padding-right: 16px;
    z-index: 98;
    box-shadow: rgba(0, 0, 0, 0.04) 0px 0px 5px;
    border-radius: 6px 6px 0 0;
    button {
      font-size: 14px;
      margin-left: 8px;
    }
  }
`
